import { render, staticRenderFns } from "./ScrollIndicator.vue?vue&type=template&id=7d5908e5&scoped=true&"
import script from "./ScrollIndicator.vue?vue&type=script&lang=js&"
export * from "./ScrollIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5908e5",
  null
  
)

export default component.exports